import React from 'react';
import {Root} from 'react-dom/client';
import {ScreenWrapperContent} from './ScreenWrapper';

export function renderScreenWrapper(root: Root) {
    root.render(<ScreenWrapperContent />);
}
